import { render, staticRenderFns } from "./OwnershipManage.vue?vue&type=template&id=48c6d3e0&scoped=true&"
import script from "./OwnershipManage.vue?vue&type=script&lang=js&"
export * from "./OwnershipManage.vue?vue&type=script&lang=js&"
import style0 from "./OwnershipManage.vue?vue&type=style&index=0&id=48c6d3e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c6d3e0",
  null
  
)

export default component.exports